import React from 'react';

import './styles.css';
import CardSkeleton from '@/ui/components/LoadingSkeleton/components/CardSkeleton';
import Spinner from '@/ui/components/Spinner';

import { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const LoadingSkeleton = ({ spinnerProps = { label: 'Loading...' } }: Props) => {
  return (
    <div className="loading-skeleton">
      <div className="animate-pulse mb-3">
        <Spinner {...spinnerProps} />
      </div>

      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
    </div>
  );
};
export default React.memo(LoadingSkeleton);
